export default __webpack_public_path__ + "static/media/banner.ff28dd06.jpg";